import React from 'react'

function TextInput({
    name,
    label,
    required,
    placeholder,
    value,
    onChange,
    onBlur,
    error,
    disabled,
    infoText,
    capitalize = true
}) {
    return (
        <div className='flex flex-col space-y-2'>
            <label
                for={name}
                className='font-semibold flex text-sm md:text-base lg:text-lg'
            >
                <p>{label}</p>
                {required && (
                    <span className='text-red-500'>*</span>
                )}
            </label>
            <input
                id={name}
                className={`text-sm md:text-base lg:text-lg border border-app-light-grey-2 rounded-lg bg-transparent px-3 py-2 text-sm sm:text-base ${capitalize && "capitalize"} focus:outline-none focus:border-2 focus:border-blue-500`}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={disabled}
                autoComplete='off'
            />
            <p className='text-xs md:text-sm text-app-grey'>{infoText}</p>
            {error && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{error}</p>
            )}
        </div>
    )
}

export default TextInput